import { inject, Injectable } from '@angular/core';
import { ApiHttpService } from '../../api-http.service';
import { ClientQuoteFee, CustomHttpResponse } from '../../../models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ClientQuoteFeeService {
  apiService: ApiHttpService<ClientQuoteFee> = inject(ApiHttpService<ClientQuoteFee>);

  getClientQuoteFeesForClientQuote(iri: string): Observable<ClientQuoteFee[]> {
    return this.apiService
      .getMany(`${iri}/client_quote_fees`)
      .pipe(map((result) => result.body['hydra:member']));
  }

  createClientQuoteFee(clientQuoteFee: ClientQuoteFee): Observable<ClientQuoteFee> {
    return this.apiService
      .post(`/client_quote_fees`, clientQuoteFee)
      .pipe(map((result: CustomHttpResponse<ClientQuoteFee>) => result.body));
  }

  delete(iri: string) {
    return this.apiService.delete(iri).pipe(map((result) => result));
  }
}
